<div class="blue-feature">
    <app-feature-hero
    variant="ims"
    title="Network QoS Monitoring"
    description="Monitor the flow of network traffic with powerful QoS tracking features"
    image=""
    imageAlt=""
></app-feature-hero>

    <section class="container section-spacing">
        <div class="row mx-0 align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-text-left">
                    <h2 class="section-title">Accelerate & Improve Network QOS Monitoring</h2>
                    <p class="section-paragraph">Infraon NMS keeps your network traffic under check by continuously monitoring and analyzing – based on categories like the class of service. Easily deal with at-risk SLAs by tracking their progress in real-time – and without facing any obstacles.</p>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-img-right justify-content-center">
                    <img src="/assets/img/feature-pages/infraon-ims/quality-of-service/nms-qos-main-illustration.png" width="80%" alt="Quality of service summary">
                </div>
            </div>
        </div>
    </section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>
    
    <section class="container section-spacing">
        <h2 class="section-title text-center p-b-60">Feature Highlights</h2>
    
        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/quality-of-service/wifi-network.svg" alt="WIFI Icon">
                </div>

                <p class="section-title-s">Bandwidth Insights</p>
                <p class="section-paragraph-s">Receive deep-dive insights on consumption data to locate which networks are consuming the most bandwidth.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/quality-of-service/monitor.svg" alt="Monitor screen">
                </div>

                <p class="section-title-s">Traffic Flow Monitoring</p>
                <p class="section-paragraph-s">Monitor the traffic flow of network devices & keep track of key parameters like packet losses, jitter, latency bandwidth, etc.</p>
            </div>
        </div>

        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/quality-of-service/file-icon.svg" alt="File icon">
                </div>

                <p class="section-title-s">Customizable QoS Reporting</p>
                <p class="section-paragraph-s">Assess Quality of Service policy performance with customized reporting modules to capture & showcase detailed traffic analysis.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/quality-of-service/headphones.svg" alt="Headphones icon">
                </div>

                <p class="section-title-s">Qos External Support</p>
                <p class="section-paragraph-s">Comprehensively measure network performance with full support for Cisco IP SLA, Juniper RPA, Huawei NQA.</p>
            </div>
        </div>
    </section>

    <section class="bg-grey">
        <div class="container section-spacing">
            <div class="row mx-0 d-flex justify-content-evenly align-items-center position-relative overflow-hidden bg-white-dots">
                <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                    <h2 class="section-title">Other Features</h2>
        
                    <div class="row mx-0 px-0">
                        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Analysis Of Traffic Patterns</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Alerts & Notifications</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph mb-0">Advanced Dashboard</p></li>
                        </ul>
                    </div>
                </div>
    
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box position-absolute" style="right: 0;bottom: 0;"> 
                    <img src="/assets/img/feature-pages/infraon-ims/quality-of-service/woman-1.webp" class="w-60" alt="woman point at features">
                </div>
            </div>
        </div>
    </section>
    

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

    <section class="container section-spacing">
        <h2 class="section-title ">FAQs</h2>
    
        <div class="row mx-0 align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 p-0">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <p class="mb-0">01 What is QoS monitoring in networking?</p>
                              
                            <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <p>QoS monitoring is the process of measuring and analyzing the performance of a network's Quality of Service (QoS) parameters, such as bandwidth, latency, packet loss, and jitter. The objective of QoS monitoring is to ensure that the network meets the required QoS standards and provides a satisfactory user experience.</p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <p class="mb-0">02 What are the benefits of QoS monitoring?</p>
                              
                            <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                        </button>
                      </h2>
                      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>QoS monitoring provides several benefits, including: </p>

                            <div class="d-flex align-items-start">
                                <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                <div class="ps-3">
                                    <p class="section-paragraph-s text-start">Ensuring that the network meets the required QoS standards and provides a satisfactory user experience </p>
                                </div>
                            </div>
                    
                            <div class="d-flex align-items-start">
                                <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                <div class="ps-3">
                                    <p class="section-paragraph-s text-start">Identifying and resolving network issues before they impact users </p>
                                </div>
                            </div>
                    
                            <div class="d-flex align-items-start">
                                <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                <div class="ps-3">
                                    <p class="section-paragraph-s text-start">Improving network performance by optimizing QoS parameters </p>
                                </div>
                            </div>
                    
                            <div class="d-flex align-items-start">
                                <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                <div class="ps-3">
                                    <p class="section-paragraph-s text-start">Monitoring and enforcing service level agreements (SLAs) </p>
                                </div>
                            </div>
                    
                            <div class="d-flex align-items-start">
                                <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                <div class="ps-3">
                                    <p class="section-paragraph-s text-start">Optimizing network resource utilization by identifying bandwidth-intensive applications or users.</p>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <p class="mb-0">03 What are the QoS parameters that can be monitored?</p>
                                
                                <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p>The QoS parameters that can be monitored include:</p>
            
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Bandwidth</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Latency</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Packet loss</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Jitter</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Throughput</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Error rate</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <p class="mb-0">04 What tools are used for QoS monitoring?</p>
                                    
                                <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                            </button>
                        </h2>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p>There are ways to collect QoS monitoring information, including:</p>

                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Network analyzers</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">SNMP (Simple Network Management Protocol)</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">IP SLA (Internet Protocol Service Level Agreement)</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">NetFlow</p>
                                    </div>
                                </div>
                        
                                <div class="d-flex align-items-start">
                                    <img src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmark icon symbolizing completion or approval">
                                    <div class="ps-3">
                                        <p class="section-paragraph-s text-start">Syslog</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFiver">
                            <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiver" aria-expanded="false" aria-controls="collapseFiver">
                                    <p class="mb-0">05 What is the role of QoS monitoring in VoIP?</p>
                                    
                                <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                            </button>
                        </h2>
                        <div id="collapseFiver" class="accordion-collapse collapse" aria-labelledby="headingFiver" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p>QoS monitoring is critical for ensuring high-quality VoIP (Voice over Internet Protocol) calls. VoIP requires low latency, low jitter, and minimal packet loss to provide a satisfactory user experience. QoS monitoring can identify network issues that affect VoIP quality and help optimize QoS parameters to ensure a smooth user experience.</p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingSix">
                            <button class="accordion-button d-flex align-items-center justify-content-between collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <p class="mb-0">06 What is the difference between QoS monitoring and network performance monitoring?</p>
                                    
                                <svg class="collapse-icon" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#0D51D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 11H17V17H11V19H17V25H19V19H25V17H19V11Z" fill="white"/></svg>
                            </button>
                        </h2>
                        <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p>QoS monitoring focuses specifically on monitoring QoS parameters to ensure that the network meets the required QoS standards and provides a satisfactory user experience. Network performance monitoring, on the other hand, focuses on monitoring overall network performance, including QoS parameters as well as other factors like device availability, utilization, and response time.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                  
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 p-0">
                <img src="/assets/img/feature-pages/faq-illustration.svg" class="mx-auto d-block w-100" alt="Guy asking FAQs">
            </div>
        </div>
    </section>
</div>